import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { buamatogVerificationKey } from './Types/Utility';

interface Props { };

function WaitForBuamatog(props : Props) {
    const [time, setTime] = useState(Date.now());

    const [initial, setInitial] = useState(true);

    useEffect(() => {
        if (initial) {
            setInitial(false);

            const buamatogkey = buamatogVerificationKey();
            const token = localStorage.getItem(buamatogkey);
            const overwrite = localStorage.getItem('buamatog-is-wonn-i-sog-2025');
            localStorage.clear();
            if (token) {
                localStorage.setItem(buamatogkey, token);
                if (overwrite) {
                    localStorage.setItem('buamatog-is-wonn-i-sog-2025', overwrite);
                }
            }
        }

        const interval = setInterval(() => setTime(Date.now()), 1000);
        return () => {
          clearInterval(interval);
        };
      }, []);

    const countdown = () => {
        const now = new Date();
        let year = (now.getFullYear());
        if (now > new Date(year + '-12-27T00:00:00')) {
            year += 1;
        }
        const buamatog = new Date(year + '-12-26T00:00:00');
        const remainingTime = Math.floor((buamatog.getTime() - now.getTime()) / 1000);

        const days = Math.floor(remainingTime / (3600 * 24));
        const hours = Math.floor((remainingTime - days * 24 * 3600) / 3600);
        const minutes = Math.floor((remainingTime % 3600) / 60);
        const seconds = remainingTime % 60;

        return `${days} TAGE
        ${hours} STUNDEN
        ${minutes} MINUTEN
        ${seconds} SEKUNDEN`;
    }

    return (
        <Box sx={{ height: '100%', display: 'grid', placeItems: 'center' }}>
            <Box>
                <img src={process.env.PUBLIC_URL + '/LogoBuamatog_512x512.png'} alt={'buamatog'} style={{ width: 'min(95vw, 512px)' }}/>
                <Box sx={{ textAlign: 'center', whiteSpace: 'pre-line' }}>
                    <Typography variant={'h4'} sx={{ fontWeight: 'bold' }}>{countdown()}</Typography>
                </Box>
            </Box>
        </Box>
    );
}

export default WaitForBuamatog;